// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { REVIEWS } from '../../../../../common/constant'
import { get } from '../../../../../common/api'


export const actionReviews = createAsyncThunk('reviewsStore/actionReviews', async (params, thunkAPI) => {
    return await get(REVIEWS, params, thunkAPI)
})


export const reviewsSlice = createSlice({
    name: 'reviewsStore',

    initialState: {

        // review list
        loadingReviews: false,
        reviewsList: null

    },
    reducers: {
        //reset or delete public store data
        resetReviewsResponse: (state) => {
            state.reviewsList = null
        }
    },
    extraReducers: builder => {
        builder
            //city
            .addCase(actionReviews.pending, (state) => {
                state.loadingReviews = true
            })
            .addCase(actionReviews.fulfilled, (state, action) => {
                state.loadingReviews = true
                state.reviewsList = action.payload
            })
            .addCase(actionReviews.rejected, (state) => {
                state.loadingReviews = false
            })
    }
})
export const { resetReviewsResponse } = reviewsSlice.actions

export default reviewsSlice.reducer